import { Grid } from "@material-ui/core";
import { useCallback, useEffect } from "react";
import { AutocompleteInput, ReferenceInput, required, TextInput, useDataProvider } from "react-admin";
import { useForm } from "react-final-form";
import { PlatformWithOrderCheckboxGroupInput } from "../../component/platform-components";
import { RegionCheckboxGroupInput } from "../../component/region-components";
import { ShelfDateTimeInput } from "./shelf-date-time-input";
import { TemplateSelectInput } from "./template-select-input";

export const EpisodeForm = (props) => {
  const formData = props.formData;
  const rest = props.rest;

  // reset the form into initial values
  const form = useForm();
  const dataProvider = useDataProvider();

  // check change of programme_id , fetch programme name , fill the field
  useEffect(async () => {
    if (formData.programme_id) {
      const result = await dataProvider.getProgrammeByProgrammeId(parseInt(formData.programme_id));

      if (result && result.data && result.data.name_tc) {
        form.change("programme_name", result.data.name_tc);
      }
    }
  }, [formData.programme_id]);

  const fetchProgramme = useCallback(async (filterType) => {
    const result = await dataProvider.getProgrammeByProgrammeId(filterType);

    form.change("programme_name", result.data.name_tc);
    form.change("title_tc", result.data.name_tc);
    form.change("title_en", result.data.name_en);
  });

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={12}>
        <AutoCompleteEpisode clearAlwaysVisible={true} fullWidth formData={formData} {...rest} allowEmpty={true} fetchProgramme={fetchProgramme} />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Programme Name" source="programme_name" disabled fullWidth />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Programme ID" source="programme_id" disabled validate={required()} fullWidth />
      </Grid>

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in EN" source="title_en" validate={required()} fullWidth />
        </Grid>
      </Grid>

      <Grid item sm={12} md={12}>
        <TemplateSelectInput layouts={["episode"]} defaultValue={"episode"} isRequired={true} />
      </Grid>

      <Grid item sm={12} md={12}>
        <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
      </Grid>

      <Grid item sm={12} md={12}>
        <RegionCheckboxGroupInput noDefaultValue={true} fullWidth />
      </Grid>

      <ShelfDateTimeInput />
    </Grid>
  );
};

const AutoCompleteEpisode = (props) => {
  const form = useForm();

  return (
    <ReferenceInput
      label="Search Programme Name"
      source="episode_autocomplete"
      reference="programmes-autocomplete"
      onChange={(val) => {
        props.fetchProgramme(val);

        form.change("programme_id", val);
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_tc: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name_tc" optionValue="programme_id" fullWidth />
    </ReferenceInput>
  );
};
